import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpscreentruth10postPostScreenTruthTargetsAppScreenIdRoleDataStateViewportRetireResponseSchema = jsonObject
export type tcpscreentruth10postPostScreenTruthTargetsAppScreenIdRoleDataStateViewportRetireResponse = z.infer<typeof tcpscreentruth10postPostScreenTruthTargetsAppScreenIdRoleDataStateViewportRetireResponseSchema>
export const tcpscreentruth10postPostScreenTruthTargetsAppScreenIdRoleDataStateViewportApproveResponseSchema = jsonObject
export type tcpscreentruth10postPostScreenTruthTargetsAppScreenIdRoleDataStateViewportApproveResponse = z.infer<typeof tcpscreentruth10postPostScreenTruthTargetsAppScreenIdRoleDataStateViewportApproveResponseSchema>
